<template lang="pug">
  .content
    .row
      .col-md-12
        .s3fileupload.text-center
          input(id="file" name="file" type='file' :multiple="true") 
          button.btn.btn-primary(@click.prevent='uploadImage') Upload
</template>
<script>
  import S3FileUpload from '../S3FileUpload/S3FileUpload.js'
  export default {
    components: {
      S3FileUpload
    },
    methods: {
      uploadImage() {
        let directory = 'images/subjects'
        let fileChooser = document.getElementById('file')
        let files = fileChooser.files
        if (files.length > 0) {
          let config = S3FileUpload.computed.config(directory)
          let S3Client = new S3FileUpload.computed.S3Client(config)
          for (let index = 0; index < files.length; index++) {
            let file = files[index]
            let fileName = file.name.split('.')[0]
            let ext = file.name.split('.')[1]
            let random = Math.random().toString().slice(2)
            let fieldName = `${random}_${fileName}`
            S3Client.uploadFile(file, fieldName).finally(() => {
              let path = `${config.s3Url}/${directory}/${fieldName}.${ext}`
              console.log(path)
            })
          }
        };
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?82397966